export default __webpack_public_path__ + "static/media/mlnlMIMFTM.3cbb3848.png";